// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-h5[data-v-65c2f8ad]{white-space:nowrap}@media only screen and (max-width:960px){.text-h5[data-v-65c2f8ad]{font-size:1.25rem!important}}@media only screen and (max-width:320px){.v-btn:not(.v-btn--round).v-size--default[data-v-65c2f8ad]{margin-right:12px;padding:0 12px}.v-btn.v-size--default[data-v-65c2f8ad]{font-size:.675rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
